import PropTypes from 'prop-types';

const Header = ({ count }) => (
  <div className="adminPanel__header">
    <h5>
      List Of Patients Registered In System: <strong>{count}</strong>
    </h5>
  </div>
);

Header.propTypes = {
  count: PropTypes.number,
};
export default Header;
